import { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material'
import { isBlank } from '../../utils/string'
import css from './ModalEditarEvaluacionAlumno.module.css'

const ACTITUDES = [
  'MUY_NEGATIVA',
  'NEGATIVA',
  'NEUTRAL',
  'POSITIVA',
  'MUY_POSITIVA'
]

const Face = ({ type, isSelected, onClick }) => (
  <div
    className={css.face}
    data-selected={isSelected}
    data-type={type}
    onClick={onClick}
  >
    <i className='material-icons'>
      {type === 'MUY_POSITIVA' && 'sentiment_very_satisfied'}
      {type === 'POSITIVA' && 'sentiment_satisfied'}
      {type === 'NEUTRAL' && 'sentiment_neutral'}
      {type === 'NEGATIVA' && 'sentiment_dissatisfied'}
      {type === 'MUY_NEGATIVA' && 'sentiment_very_dissatisfied'}
    </i>
  </div>
)

const ModalEditarEvaluacionAlumno = ({
  open,
  alumno = '',
  asignaturas = [],
  onSubmit,
  onClose,
  disabled = false
}) => {
  const [form, setForm] = useState({
    actitud: '',
    limpieza: '',
    asignaturas: {},
    observaciones: ''
  })

  useEffect(() => {
    if (open) {
      const asignaturasEvaluadas = asignaturas.reduce((acc, e) => {
        acc[e.asignaturaId] = e.valoracion
        return acc
      }, {})

      setForm({
        actitud: alumno?.actitud || '',
        limpieza: alumno?.limpieza || '',
        asignaturas: asignaturasEvaluadas,
        observaciones: alumno?.observaciones || ''
      })
    }
  }, [open, alumno, asignaturas])

  const handleEvaluacionActitudChange = type => {
    setForm(prev => ({ ...prev, actitud: type }))
  }

  const handleEvaluacionLimpiezaChange = type => {
    setForm(prev => ({ ...prev, limpieza: type }))
  }

  const handleEvaluacionAsignaturaChange = (asignatura, type) => {
    setForm(prev => ({
      ...prev,
      asignaturas: { ...prev.asignaturas, [asignatura]: type }
    }))
  }

  const handleSubmit = () => {
    const payload = {
      id: alumno?.id,
      actitud: form.actitud,
      limpieza: form.limpieza,
      asignaturas: form.asignaturas,
      observaciones: form.observaciones
    }
    onSubmit(payload)
  }

  const isSubmitDisabled =
    isBlank(form.actitud) ||
    isBlank(form.limpieza) ||
    asignaturas.some(item => isBlank(form.asignaturas[item.asignaturaId]))

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='sm'>
      <DialogTitle>Evaluación de {alumno?.nombre}</DialogTitle>
      <DialogContent className={css.main}>
        <div className={css.section}>
          <DialogContentText className={css.sectionTitle}>
            Actitud
          </DialogContentText>
          <div className={css.faces}>
            {ACTITUDES.map(type => (
              <Face
                key={`actitud-${type}`}
                type={type}
                isSelected={type === form.actitud}
                onClick={() => handleEvaluacionActitudChange(type)}
              />
            ))}
          </div>
        </div>
        <div className={css.section}>
          <DialogContentText className={css.sectionTitle}>
            Limpieza
          </DialogContentText>
          <div className={css.faces}>
            {ACTITUDES.map(type => (
              <Face
                key={`limpieza-${type}`}
                type={type}
                isSelected={type === form.limpieza}
                onClick={() => handleEvaluacionLimpiezaChange(type)}
              />
            ))}
          </div>
        </div>
        {asignaturas.map(item => (
          <div key={item.asignaturaId}>
            <div className={css.section}>
              <DialogContentText className={css.sectionTitle}>
                Eficacia ({item.asignatura})
              </DialogContentText>
              <div className={css.faces}>
                {ACTITUDES.map(type => (
                  <Face
                    key={`${item.asignaturaId}-${type}`}
                    type={type}
                    isSelected={type === form.asignaturas[item.asignaturaId]}
                    onClick={() =>
                      handleEvaluacionAsignaturaChange(item.asignaturaId, type)
                    }
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
        <div className={css.section}>
          <TextField
            label='Observaciones'
            placeholder='Escribe cualquier observación (opcional)'
            multiline
            rows={4}
            variant='standard'
            fullWidth
            value={form.observaciones}
            onChange={e =>
              setForm(prev => ({ ...prev, observaciones: e.target.value }))
            }
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          color='primary'
          onClick={handleSubmit}
          disabled={isSubmitDisabled || disabled}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEditarEvaluacionAlumno
